export const hasHTMLElement = (str: string) => {
  return /<\/?[a-z][\s\S]*>/i.test(str);
};
